import { lazy, type MouseEvent, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Layout } from "./components/Layout";

const HomePage = lazy(() => import("./pages/HomePage"));
const TicketsPage = lazy(() => import("./pages/TicketsPage"));
const TicketDetailPage = lazy(() => import("./pages/TicketDetailPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const LegalPage = lazy(() => import("./pages/LegalPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

const Loading = () => (
  <div className="page-loading" role="status" aria-live="polite">
    <span className="loading-ring" aria-hidden="true" />
    Loading race weekend…
  </div>
);

export default function App() {
  const skipToContent = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const main = document.getElementById("main-content");
    main?.focus({ preventScroll: true });
    main?.scrollIntoView({ block: "start" });
  };

  return (
    <ErrorBoundary>
      <a className="skip-link" href="#main-content" onClick={skipToContent}>Skip to content</a>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="tickets" element={<TicketsPage />} />
            <Route path="tickets/:slug" element={<TicketDetailPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="terms" element={<LegalPage type="terms" />} />
            <Route path="privacy" element={<LegalPage type="privacy" />} />
            <Route path="refund-policy" element={<LegalPage type="refund" />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
